// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2LER0","modalForm":"UpgradeEpcsModal_modalForm__1B97Q","modalFooter":"UpgradeEpcsModal_modalFooter__1z2xW"};